import React from "react";
import { motion } from "framer-motion";
import { useT } from "../../i18n";

const IMG =
  "https://images.unsplash.com/photo-1564471925181-982d3a6c1a3f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function Principles() {
  const { t } = useT();
  const items = t("principles.items") || [];
  return (
    <section
      id="principles"
      className="relative overflow-hidden bg-[#1a211c] text-[#f6f4ee] py-24 md:py-36"
      data-testid="principles-section"
    >
      <div className="absolute inset-0 opacity-25">
        <img
          src={IMG}
          alt=""
          className="h-full w-full object-cover"
          aria-hidden="true"
          loading="lazy"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#1a211c]/70 via-[#1a211c]/85 to-[#1a211c]" />

      <div className="relative max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-14">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl"
        >
          <div className="eyebrow mb-6" style={{ color: "#c5b293" }}>
            <span className="text-[#c5b293]">{t("principles.sectionLabel")}</span>
          </div>
          <h2 className="font-serif tracking-tight leading-[1.05] text-[clamp(2rem,5vw,4rem)]">
            {t("principles.title")}
          </h2>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-x-14 gap-y-10">
          {items.map((it, i) => (
            <motion.div
              key={it.k}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="pt-6 border-t border-[#f6f4ee]/15"
              data-testid={`principle-${i}`}
            >
              <div className="flex items-baseline justify-between mb-3">
                <span className="font-mono text-[0.7rem] tracking-[0.24em] text-[#c5b293]">
                  0{i + 1}
                </span>
              </div>
              <h3 className="font-serif text-2xl md:text-3xl leading-tight mb-3">{it.k}</h3>
              <p className="text-[0.98rem] leading-relaxed text-[#f6f4ee]/75">{it.v}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
